import React from "react";
import AbsoluteWrapper from "./AbsoluteWrapper";
import { NavLink, Link } from "react-router-dom";

import mapping          from './pictures/mapping.PNG' ; //Trade_History




const slides = [
  /*{ id: 0, url: 'photo-1544511916-0148ccdeb877?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1901&q=80i' },
  { id: 1, url: 'photo-1544572571-ab94fd872ce4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1534&q=80' },
  { id: 2, url: 'reserve/bnW1TuTV2YGcoh1HyWNQ_IMG_0207.JPG?ixlib=rb-1.2.1&w=1534&q=80' },
  { id: 3, url: 'photo-1540206395-68808572332f?ixlib=rb-1.2.1&w=1181&q=80' },*/
 /* { id: 0, url: './pictures/images_0.jpg' },
  { id: 1, url: './pictures/images_1.jpg' },
  { id: 2, url: './pictures/images_2.jpg' },
  { id: 3, url: './pictures/images_3.jpg' },
  { id: 4, url: './pictures/images_4.jpg' },
  { id: 5, url: './pictures/images_5.jpg' },
  { id: 6, url: './pictures/images_6.jpg' },*/
  //{ id: 7, url: './pictures/images_7.jpg' },
  //{ id: 8, url: './pictures/images_8.jpg' },
  { id: 17, url: './pictures/images_17.jpg' },
  { id: 10, url: './pictures/images_10.jpg' },
  { id: 11, url: './pictures/images_11.jpg' },
  { id: 12, url: './pictures/images_12.jpg' },
  { id: 13, url: './pictures/images_13.jpg' },
  { id: 14, url: './pictures/images_14.jpg' },
  { id: 15, url: './pictures/images_15.jpg' },
  { id: 16, url: './pictures/images_16.jpg' },
  { id: 17, url: './pictures/images_17.jpg' },
  { id: 18, url: './pictures/images_18.jpg' },
  //{ id: 19, url: './pictures/images_19.jpg' },
  { id: 20, url: './pictures/images_20.jpg' },
  { id: 21, url: './pictures/images_21.jpg' },
  { id: 22, url: './pictures/images_22.jpg' },
  { id: 23, url: './pictures/images_23.jpg' },
  { id: 24, url: './pictures/images_24.jpg' },
  { id: 25, url: './pictures/images_25.jpg' },
  { id: 26, url: './pictures/images_26.jpg' },
  { id: 27, url: './pictures/images_27.jpg' },
  { id: 28, url: './pictures/images_28.jpg' },
  { id: 29, url: './pictures/images_29.jpg' },
  { id: 30, url: './pictures/images_30.jpg' },

]


var divStyle = {
  color: 'blue',
  cursor: 'pointer',
}

//                  <a href="http://idms-firm-filali.com.s3-website-us-west-2.amazonaws.com/solution"   style = {divStyle} className="left_leran">Learn more ...</a> 

const PageOne = () => {
    //<h4 className="card-title mt-1">I'm PageTwo!</h4>
    //<img className="card-title mt-1"  src="https://placeimg.com/640/480/any/1/"></img>
    //<li  className="padding-metis"><a     id ="Strategy" aria-expanded="false" ><i className="fa fa-home tab"></i><span className="titleM">Dashboard2</span></a></li>
  return (
    <AbsoluteWrapper>
      <section className="row justify-content-center text-center p-5" >
        <article className="col-md-8">
          <div className="card p-1 m-1 shadow">
            <div className="card-body">

            <img className="card-title mt-1"  src="./pictures/images_10.jpg" width="108%"  height="500px"></img>
              
            </div>
            
          </div>

              <br></br>
              <br></br>
              <br></br>

          <h4  style = {{color: 'rgb(43, 97, 245)'}} >What's Included in Your Product</h4>

          <div className="wrapper-line-login"></div>

          <br></br>




          <div   id = "signal-report"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >
          <br></br>
          <a    className="logo-position"   id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_7.jpg"></img><span className="doc-content-title">Core Platform Capabilities & Trading Strategy </span></a>
          <br></br>
                     <div className="wrapper_line"></div>
                     <br></br>
                   <p id="page_summary_idx" className="text-position">
                   <span>Our ecosystem combines hybrid trading intelligence with automated execution infrastructure, integrating : </span>
                   <br></br>
                   <span>• &nbsp; &nbsp; 	 	 Secure multi-broker copy-trading architecture supporting MetaTrader 5, Ndax and Interactive Brokers </span>
                   <span>• &nbsp; &nbsp; 	 	 Real-time multi-timeframe market mapping and synchronization  </span>
                   <span>• &nbsp; &nbsp; 	 	 Structured indicator-state classification and regime modeling </span>
                   <span>• &nbsp; &nbsp; 	 	 Machine learning and deep learning driven market behavior analysis </span>
                   <span>• &nbsp; &nbsp; 	 	 Centralized risk governance and trade management controls  </span>
                   <span>• &nbsp; &nbsp; 	 	 Scalable cloud-based infrastructure for live strategy deployment </span>
    
                  </p>
                  <br></br>
                  <img src="./pictures/images_22.jpg"     className="shadow"  height = "300px" width="50%"  ></img>
                  <br></br>  
                  <br></br>
   


                  <p id="page_summary_idx" className="text-position">
                  This enables the environment to identify higher-probability execution conditions while maintaining adaptive risk management across changing market regimes.
                  
                  <br></br>  
                  <br></br>  


                  <NavLink
                    exact
                    to="/solution"
                    cursor= "pointer"
                    style = {divStyle}
                    className="left_leran"
                  >
                    Learn more ...
                  </NavLink>
                
                  <br></br>  
                  
                  
                  </p>
                  <br></br>
		      </div>



          <br></br>

          <div   id = "signal-report"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >
          <br></br>
          <a    className="logo-position"   id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_12.jpg"></img><span className="doc-content-title">Charts  & Technical Indicators </span></a>
          <br></br>
                     <div className="wrapper_line"></div>
                     <br></br>
                   <p id="page_summary_idx" className="text-position">

                   <span>This service includes the following features : </span>
                  
                    <br></br>
                    <span>• &nbsp; &nbsp; 	 Relative Strength Index (RSI) for momentum evaluation and potential reversal</span>
                    <span>• &nbsp; &nbsp; 	 Average True Range (ATR) for volatility measurement and adaptive stop-loss calibration</span>
                    <span>• &nbsp; &nbsp; 	 Moving averages and trend-alignment indicators</span>
                    <span>• &nbsp; &nbsp; 	 Volatility and liquidity monitoring tools</span>
                    <span>• &nbsp; &nbsp; 	 Multi-timeframe indicator-state classification models. </span>
                   

                  </p>

                  <br></br>
                  <img src="./pictures/phd.jpg"  className="shadow" height = "300px"  width="50%"   ></img>
                  <br></br>
          


                  <p id="page_summary_idx" className="text-position">

                  <NavLink
                    exact
                    to="/solution"
                    cursor= "pointer"
                    style = {divStyle}
                    className="left_leran"
                  >
                    Learn more ...
                  </NavLink>
                
                  <br></br>  
                  
                  </p>
                  <br></br>


		      </div>

          <br></br>


        <div   id = "signal-report"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >
          <br></br>
          <a    className="logo-position"   id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_12.jpg"></img><span className="doc-content-title">Trading Range Vector™ - True Trading Range (TTR)</span></a>
          <br></br>
                     <div className="wrapper_line"></div>
                     <br></br>
                   <p id="page_summary_idx" className="text-position">

                   <span>Identifying the True Trading Range (TTR) is a critical component of the platform’s analytical and risk-management infrastructure.</span>
                   <span>The framework dynamically maps :</span>
                   
                    <br></br>
                    <span>• &nbsp; &nbsp; 	  Closest potential support and resistance levels </span>
                    <span>• &nbsp; &nbsp; 	  Upper and lower pivot structures </span>
                    <span>• &nbsp; &nbsp; 	  Volatility-adjusted price boundaries </span>
                    <span>• &nbsp; &nbsp; 	  Momentum and reversal pressure areas  </span>
                    <span>• &nbsp; &nbsp; 	  Multi-timeframe market-range synchronization </span>
                   

                  </p>

                  <br></br>
                  <img src={process.env.PUBLIC_URL  +"/pictures/images_29.png" }  className="shadow" height = "300px"  width="50%"   />
                  <br></br>


                  <p id="page_summary_idx" className="text-position">

                  <NavLink
                    exact
                    to="/solution"
                    cursor= "pointer"
                    style = {divStyle}
                    className="left_leran"
                  >
                    Learn more ...
                  </NavLink>
                
                  <br></br>  
                  
                  </p>
                  <br></br>


		      </div>

         <br></br>


           <div   id = "signal-report"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >
          <br></br>
          <a    className="logo-position"   id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_12.jpg"></img><span className="doc-content-title">Trading Range Vector™ - Streaming Trading Range Intelligence</span></a>
          <br></br>
                     <div className="wrapper_line"></div>
                     <br></br>
                   <p id="page_summary_idx" className="text-position">

                   <span>The platform continuously provides live-streaming trading-range metrics directly within the charting environment, including:</span>
                   <span>The framework dynamically maps :</span>
                   <br></br>


                    <span>• &nbsp; &nbsp; 	   Dynamic lower and upper pivot values </span>
                    <span>• &nbsp; &nbsp; 	   Real-time range expansion and contraction analysis  </span>
                    <span>• &nbsp; &nbsp; 	   Volatility-sensitive boundary adjustments  </span>
                    <span>• &nbsp; &nbsp; 	   Risk-aware directional bias monitoring  </span>
                    <span>• &nbsp; &nbsp; 	   Interactive mapping overlays and alerts </span>

                     <br></br>
                  
                   

                  </p>

                  <img src={process.env.PUBLIC_URL  +"/pictures/images_29.png"}  className="shadow" height = "300px"  width="50%"   />
                  <br></br>
                  <br></br>


                  <p id="page_summary_idx" className="text-position">

                      <span>These components operate as additional decision-support tools within the broader iDMS analytical ecosystem</span>

                  <NavLink
                    exact
                    to="/solution"
                    cursor= "pointer"
                    style = {divStyle}
                    className="left_leran"
                  >
                    Learn more ...
                  </NavLink>
                
                  <br></br>  
                  
                  </p>
                  <br></br>


		      </div>

         <br></br>


        <div   id = "signal-report"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >
          <br></br>
          <a    className="logo-position"   id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_12.jpg"></img><span className="doc-content-title">Momentum Trend Signals Engine</span></a>
          <br></br>
                     <div className="wrapper_line"></div>
                   <p id="page_summary_idx" className="text-position">

                     <br></br>
                          <span>These signals are generated when the system detects continuation strength and directional momentum alignment across structured indicator states and multiple timeframes.  The objective is to identify:</span>

                          <br></br>
                          <span>• &nbsp; &nbsp; 	 Trend continuation opportunities</span>
                          <span>• &nbsp; &nbsp; 	 Momentum acceleration conditions</span>
                          <span>• &nbsp; &nbsp; 	 Breakout and expansion behavior</span>
                          <span>• &nbsp; &nbsp; 	 High-probability directional bias environments</span>
                   

                  </p>

                  <br></br>
                  <img src="./pictures/images_15.jpg"  className="shadow" height = "300px"  width="50%"   ></img>
                  <br></br>

                  <p id="page_summary_idx" className="text-position">

                  <NavLink
                    exact
                    to="/solution"
                    cursor= "pointer"
                    style = {divStyle}
                    className="left_leran"
                  >
                    Learn more ...
                  </NavLink>
                
                  <br></br>  
                  
                  </p>
                  <br></br>


		      </div>

         <br></br>


           <div   id = "signal-report"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >
          <br></br>
          <a    className="logo-position"   id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_12.jpg"></img><span className="doc-content-title">Reversal Trend Signals Engine</span></a>
          <br></br>
                     <div className="wrapper_line"></div>
                     <br></br>
                   <p id="page_summary_idx" className="text-position">


                          <span>Reversal alerts are generated when the analytical engine identifies potential exhaustion conditions, momentum deceleration, or overextended price behavior that may indicate a possible trend reversal.  These signals incorporate :</span>

                          <br></br>
                          <span> • &nbsp; &nbsp; 	 Momentum divergence analysis</span>
                          <span> • &nbsp; &nbsp; 	 Volatility transition behavior</span>
                          <span> • &nbsp; &nbsp; 	 Support and resistance interaction</span>
                          <span> • &nbsp; &nbsp; 	 Multi-timeframe reversal confirmation logic</span>

                         <br></br>

                   

                  </p>

                  <img src="./pictures/images_15.jpg"  className="shadow" height = "300px"  width="50%"   ></img>
                  <br></br>
                  <br></br>

                  <p id="page_summary_idx" className="text-position">

                  <NavLink
                    exact
                    to="/solution"
                    cursor= "pointer"
                    style = {divStyle}
                    className="left_leran"
                  >
                    Learn more ...
                  </NavLink>
                
                  <br></br>  
                  
                  </p>


		      </div>




           <div   id = "signal-report"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >
          <a    className="logo-position"   id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_12.jpg"></img><span className="doc-content-title">Interactive Alerting Environment</span></a>
          <br></br>
                     <div className="wrapper_line"></div>
                     <br></br>
                   <p id="page_summary_idx" className="text-position">

                          
                          <span>The platform delivers alerts through an event-driven infrastructure supporting:</span>
                          <br></br>

                          <span> • &nbsp; &nbsp; 	 Real-time notifications</span>
                          <span> • &nbsp; &nbsp; 	 Interactive chart overlays</span>
                          <span> • &nbsp; &nbsp; 	 Semantic signal classification</span>
                          <span> • &nbsp; &nbsp; 	 Sound-based alert systems</span>
                          <span> • &nbsp; &nbsp; 	 Live monitoring dashboards</span>
                          <span> • &nbsp; &nbsp; 	 Risk-aware execution workflows</span>

                          <br></br>
                         

                         <br></br>

                   

                  </p>

                  <br></br>
                  <img src="./pictures/images_14.jpg"  className="shadow" height = "300px"  width="50%"   ></img>
                  <br></br>
                  <br></br>


                  <p id="page_summary_idx" className="text-position">

                     <span>This creates a fully integrated signal environment where analytical intelligence, risk management, and execution monitoring operate together within a unified decision-support ecosystem.</span>

                  <NavLink
                    exact
                    to="/solution"
                    cursor= "pointer"
                    style = {divStyle}
                    className="left_leran"
                  >
                    Learn more ...
                  </NavLink>
                
                  <br></br>  
                  
                  </p>
                  <br></br>


		      </div>


         
           <div   id = "signal-report"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >
          <br></br>
          <a    className="logo-position"   id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_12.jpg"></img><span className="doc-content-title">MCycle™ — Momentum Cycle Trigger & Applications</span></a>
          <br></br>
                     <div className="wrapper_line"></div>
                   <p id="page_summary_idx" className="text-position">

                   <span>The framework can be used to support:</span>
                   <br></br>


                    <span>• &nbsp; &nbsp; 	   Active position exit strategies </span>
                    <span>• &nbsp; &nbsp; 	   Momentum exhaustion monitoring </span>
                    <span>• &nbsp; &nbsp; 	   Early reversal opportunity detection  </span>
                    <span>• &nbsp; &nbsp; 	   Risk-reduction workflows </span>
                    <span>• &nbsp; &nbsp; 	   Counter-trend entry preparation under prior due diligence</span>

                     <br></br>
                   
                   

                  </p>

                  <img src="./pictures/images_14.jpg"  className="shadow" height = "300px"  width="50%"   ></img>
                  <br></br>
                  <br></br>


                  <p id="page_summary_idx" className="text-position">

                     <span>Rather than functioning as a standalone indicator, MCycle™ operates as part of the broader iDMS intelligence ecosystem to provide additional contextual awareness surrounding evolving market-cycle conditions.</span>

                  <NavLink
                    exact
                    to="/solution"
                    cursor= "pointer"
                    style = {divStyle}
                    className="left_leran"
                  >
                    Learn more ...
                  </NavLink>
                
                  <br></br>  
                  
                  </p>
                  <br></br>


		      </div>

         <br></br>



                  <div   id = "signal-report"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >
          <br></br>
            <br></br>

          <a    className="logo-position"   id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_30.jpg"></img><span className="doc-content-title">Interactive Market & Chart Mapping Intelligence</span></a>
                     <br></br>
                     <div className="wrapper_line"></div>
                     <br></br>
                   <p id="page_summary_idx" className="text-position">
                   <span>Rather than displaying isolated indicators independently, the system structures market information into a contextual mapping environment where momentum, volatility, trend behavior, and regime conditions are visualized collectively to support more informed investment and trading decisions.</span>
                  </p>
                  <br></br>
                  <img src= {mapping}  className="shadow"  height = "500px" width="30%"   ></img>
                  <br></br>
                  <br></br>

                  <p id="page_summary_idx" className="text-position">
                    <span>Our visualization ecosystem combines candlestick charting, dynamic market mapping, and structured indicator analysis within a unified trading interface optimized for multi-timeframe monitoring</span>


                    <br></br>    

                    <NavLink
                    exact
                    to="/solution"
                    cursor= "pointer"
                    style = {divStyle}
                    className="left_leran"
                  >
                    Learn more ...
                  </NavLink>


                    <br></br>  

                  </p>
                  <br></br>
		      </div>

           <br></br>



          <div   id = "signal-report"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >
          <br></br>
          <a    className="logo-position"   id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_30.jpg"></img><span className="doc-content-title">Risk Management - Price Path Simulation  - Value-at-Risk (VaR)</span></a>
          <br></br>
                     <div className="wrapper_line"></div>
                     <br></br>
                   <p id="page_summary_idx" className="text-position">
                   <span>We provide the market price of risk which is obtained from futures prices. A risk-neutral Monte Carlo simulation / A Random Walk concept is conducted using a mean-reverting model with seasonality and a jump component. The model is calibrated under the real-world probability using more than 10 years historical stock prices.</span>
                   <span>A risk profile identifies the acceptable level of risk an individual is prepared and able to accept. An investor's risk profile attempts to determine how a willingness to take on risk (or an aversion to risk) will affect an overall decision-making strategy.</span>
                  </p>
                  <br></br>
                  <img src="./pictures/images_24.jpg"  className="shadow"  height = "300px" width="50%"   ></img>
                  <br></br>
                  <br></br>

                  <p id="page_summary_idx" className="text-position">
                    <span>The platform also provides Value at Risk (VaR) analysis and risk-profile curve visualization to estimate potential portfolio exposure under adverse market scenarios.</span>
                    <span>By combining stochastic modeling, volatility analytics, and real-time monitoring infrastructure, the environment delivers a structured and adaptive framework for investment risk governance and decision support.</span>


                    <br></br>    

                    <NavLink
                    exact
                    to="/solution"
                    cursor= "pointer"
                    style = {divStyle}
                    className="left_leran"
                  >
                    Learn more ...
                  </NavLink>


                    <br></br>  

                  </p>
		      </div>



          <div   id = "signal-report"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >

          <a    className="logo-position"   id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_20.jpg"></img><span className="doc-content-title">Dashboard , Reporting System & Trade Lifecycle Monitoring </span></a>
          <br></br>
                     <div className="wrapper_line"></div>
                     <br></br>

                   <p id="page_summary_idx" className="text-position">
                      <span>Each hypothetical transaction generated by the platform maintains a complete lifecycle profile, enabling detailed analysis of : </span>
                      <br></br>
                      <span>• &nbsp; &nbsp; 	 	Entry and exit conditions  </span>
                      <span>• &nbsp; &nbsp; 	 	Indicator-state evolution   </span>
                      <span>• &nbsp; &nbsp; 	 	Regime transitions during trade duration  </span>
                      <span>• &nbsp; &nbsp; 	 	Momentum and volatility behavior  </span>
                      <span>• &nbsp; &nbsp; 	 	Time-risk exposure  </span>
                      <span>• &nbsp; &nbsp; 	 	Risk/reward profile evolution  </span>
                       <br></br>
                     
                  </p>



                  <br></br>
                  <img src="./pictures/images_20.jpg"  className="shadow"  height = "300px" width="50%"   ></img>
                  <br></br>
                  <br></br>




                  <p id="page_summary_idx" className="text-position">

                     <span>This structured historical framework supports advanced analytics, machine learning model training, strategy optimization, and long-term performance evaluation embedded in Cloud-Based Intelligence Environment.</span>
                     <span>Built on scalable cloud-computing infrastructure, the reporting system is designed to support high-volume market monitoring and real-time analytical processing while maintaining accessibility, flexibility, and operational scalability across future web, desktop, and mobile environments.</span>

                      <NavLink
                    exact
                    to="/solution"
                    cursor= "pointer"
                    style = {divStyle}
                    className="left_leran"
                  >
                    Learn more ...
                  </NavLink>

                  <br></br>  
                  
                  
                  </p>

                  <br></br>





                  <div   id = "signal-report"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >
          <br></br>
          <a    className="logo-position"   id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_22.jpg"></img><span className="doc-content-title">Mass Communication System</span></a>
          <br></br>
                     <div className="wrapper_line"></div>
                     <br></br>
                   <p id="page_summary_idx" className="text-position">
                   <span>This live mass communication system is used as an important channel to communicate as needed a major market information generated by our admin console system. </span>
                   <span>The system is designed to be another additional decision making system tool. </span>
                   </p>
                

                  <img src="./pictures/images_22.jpg"  className="shadow"  height = "300px" width="50%"   ></img>
                  <br></br>

                  <p id="page_summary_idx" className="text-position">


                  <NavLink
                    exact
                    to="/solution"
                    cursor= "pointer"
                    style = {divStyle}
                    className="left_leran"
                  >
                    Learn more ...
                  </NavLink>
                

                  <br></br>  
                  
                  
                  </p>
                  <br></br>
		      </div>


          <br></br>


		      </div>




        </article>
      </section>
    </AbsoluteWrapper>
  );
};

export default PageOne;
